import {Component, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {ChangeRequestService} from '../../services/change-request.service';
import {TechCheckResult} from '../../generate/TechCheckAPI';
import {Title} from "@angular/platform-browser";

declare var jQuery: any;

@Component({
    selector: 'tech-check-request-details',
    templateUrl: './tech-check-request-details.component.html',
    styleUrls: ['./tech-check-request-details.component.scss'],
    standalone: false
})
export class TechCheckRequestDetailsComponent implements OnInit {

  loadingData: boolean;

  techCheckResult: TechCheckResult = {};

  changeRequestID: string = '';

  techCheckTestId: string = '';

  domainName: string = '';

  constructor(
      private activatedRoute: ActivatedRoute,
      private router: Router,
      private location: Location,
      private changeRequestService: ChangeRequestService,
      private titleService: Title) {
  }


  ngOnInit() {
      this.titleService.setTitle('View Technical Check Results');
      this.loadingData = true;
      this.getInputData();
  }

  onBack() {
    this.location.back();
  }

  getInputData() {
    if (this.activatedRoute.snapshot || !this.activatedRoute.snapshot.paramMap) {
      this.changeRequestID = this.activatedRoute.snapshot.paramMap.get('requestNumber');
      this.techCheckTestId = this.activatedRoute.snapshot.paramMap.get('techCheckID');
      this.domainName = this.activatedRoute.snapshot.paramMap.get('domain');
      this.changeRequestService.getTechnicalCheckResponse(this.changeRequestID, this.techCheckTestId).subscribe(data => {
        this.techCheckResult = data;
      }, error => {
        console.log(error);
        this.loadingData = false;
      }, () => {
        this.loadingData = false;
      });
    } else {
      this.router.navigateByUrl('/user/home');
    }
  }


  openLog() {
    let newWindow = window.open('/' + this.changeRequestID + '/tech-check-log/' + this.techCheckTestId, '_blank');
    newWindow['changeRequestID'] = this.changeRequestID;
    newWindow['data'] = this.techCheckResult.statusCheck.logs;

  }

  initAccordion() {
    jQuery('#accordation-list').foundation();
  }

}
